(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-banner"] && !Shopify.designMode) return;
  try {
    
  class VhBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.#set(0);

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.observer = new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            if (e.isIntersecting) this.#set(this.slides.indexOf(e.target));
          }),
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));

      this.delay = Number(this.dataset.autoplay) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.playing = this.delay > 0 && !this.reduced;
      this.play = this.querySelector('[data-play]');
      this.play?.addEventListener('click', () => {
        this.playing = !this.playing;
        this.#ui();
        this.#tick();
      });
      const pause = (on) => () => {
        this.paused = on;
        this.#tick();
      };
      this.addEventListener('pointerenter', pause(true));
      this.addEventListener('pointerleave', pause(false));
      this.addEventListener('focusin', pause(true));
      this.addEventListener('focusout', pause(false));
      this.track.addEventListener('touchstart', pause(true), { passive: true });
      this.track.addEventListener('touchend', pause(false), { passive: true });
      document.addEventListener('visibilitychange', () => this.#tick());
      document.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target);
        if (i > -1) this.go(i);
      });
      this.#ui();
      this.#tick();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
    }

    go(i) {
      const n = this.slides.length;
      const target = this.slides[(i + n) % n];
      this.track.scrollTo({ left: target.offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
      this.#tick();
    }

    #set(i) {
      if (i < 0) return;
      this.index = i;
      this.slides.forEach((slide, k) => slide.toggleAttribute('inert', k !== i));
      this.dots.forEach((dot, k) => (k === i ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
    }

    #ui() {
      if (!this.play) return;
      this.play.toggleAttribute('data-paused', !this.playing);
      this.play.setAttribute('aria-label', this.playing ? this.play.dataset.pauseLabel : this.play.dataset.playLabel);
    }

    #tick() {
      clearInterval(this.timer);
      if (this.playing && !this.paused && !document.hidden) {
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }
    }
  }
  if (!customElements.get('vh-banner')) customElements.define('vh-banner', VhBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-vh-more]') : null;
    if (!btn) return;
    const list = btn.parentElement.querySelector('[data-vh-more-list]');
    list?.querySelectorAll('[data-vh-more-item]').forEach((li) => (li.hidden = false));
    btn.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class VhRecentlyViewed extends HTMLElement {
    async connectedCallback() {
      const KEY = 'vh-recent';
      const current = this.dataset.current;
      const limit = Number(this.dataset.limit) || 8;
      let list = [];
      try {
        list = JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) {
        list = [];
      }
      const others = list.filter((h) => h !== current).slice(0, limit);
      try {
        if (current) localStorage.setItem(KEY, JSON.stringify([current, ...others].slice(0, 12)));
      } catch (e) {
        /* depolama kapalı */
      }
      if (!others.length) return;

      const money = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' });
      const root = window.Shopify?.routes?.root || '/';
      const items = await Promise.all(
        others.map((h) =>
          fetch(`${root}products/${encodeURIComponent(h)}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      const ul = this.querySelector('[data-list]');
      items.filter(Boolean).forEach((p) => {
        const li = document.createElement('li');
        li.className = 'vh-recent__item';
        const a = document.createElement('a');
        a.href = p.url;
        a.className = 'vh-recent__card';
        if (p.featured_image) {
          const img = document.createElement('img');
          img.src = `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=400`;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 400;
          img.height = 500;
          a.append(img);
        }
        const t = document.createElement('span');
        t.className = 'vh-recent__title';
        t.textContent = p.title;
        const pr = document.createElement('span');
        pr.className = 'vh-recent__price';
        pr.textContent = money.format(p.price / 100);
        if (p.compare_at_price > p.price) {
          pr.classList.add('is-sale');
          const s = document.createElement('s');
          s.textContent = money.format(p.compare_at_price / 100);
          pr.append(' ', s);
        }
        a.append(t, pr);
        li.append(a);
        ul.append(li);
      });
      if (ul.children.length) this.hidden = false;
    }
  }
  if (!customElements.get('vh-recently-viewed')) customElements.define('vh-recently-viewed', VhRecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-room-sizes"] && !Shopify.designMode) return;
  try {
    
  class VhRoomSizes extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.#select(i));
        tab.addEventListener('keydown', (event) => {
          const n = this.tabs.length;
          const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: n - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          this.#select((keys[event.key] + n) % n, true);
        });
      });
      this.panels.forEach((panel) => {
        panel.querySelectorAll('[data-size]').forEach((btn) => btn.addEventListener('click', () => this.#size(panel, btn)));
        const first = panel.querySelector('[data-size]');
        if (first) panel.querySelector('[data-plan]')?.setAttribute('aria-label', first.dataset.label);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const i = this.panels.indexOf(event.target);
        if (i > -1) this.#select(i);
      });
    }

    #select(i, focus = false) {
      this.tabs.forEach((tab, k) => {
        tab.setAttribute('aria-selected', String(k === i));
        tab.tabIndex = k === i ? 0 : -1;
      });
      this.panels.forEach((panel, k) => (panel.hidden = k !== i));
      if (focus) this.tabs[i].focus();
      this.tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    #size(panel, btn) {
      panel.querySelectorAll('[data-size]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      panel.querySelectorAll('[data-rug]').forEach((g) => g.classList.toggle('is-active', g.dataset.rug === btn.dataset.size));
      panel.querySelector('[data-plan]')?.setAttribute('aria-label', btn.dataset.label);
    }
  }
  if (!customElements.get('vh-room-sizes')) customElements.define('vh-room-sizes', VhRoomSizes);

  } catch(e) { console.error(e); }
})();
})();
